<header class="bg-white sticky top-0 z-50 print:hidden">
  <div class="max-w-7xl mx-auto px-3">
    <div class="flex items-center justify-center h-14 md:h-20 relative">
      <a [href]="logoUrl()" class="h-full">
        <img
          ngSrc="{{ logoUrl() }}img/logo@2x.png"
          alt="Chef Ami logo"
          width="110"
          height="50"
          priority
          class="h-full w-auto"
        />
      </a>
    </div>
  </div>
</header>
